import React from "react"
import { ThemeProvider } from "styled-components"
//STYLES
import { GlobalStyle } from "../utils/globalStye"
import { theme } from "../utils/theme"
//DATA
import { info } from "../assets/data/kontakt"
import Cookie from "../components/cookie/Cookie"
//NAVBAR
import Navbar from "../components/navbar/Navbar_Container"
import NavbarHeader from "../components/navbar/NavbarHeader_Multilang"
//FOOTER
import Footer from "../components/footer/footer/footer2"
import FooterHeader from "../components/footer/footerHeader/FooterHeader_Card"
import FooterIks from "../components/footer/footerIks/FooterIks"

const Layout = props => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <div>
        {/* <NavbarHeader
          intro="Zapraszamy na wizytę"
          tel={info.tel}
          email={info.mail}
          lang={props.lang}
          slug={props.slug}
        /> */}

        <Navbar lang={props.lang} slug={props.slug} />

        <div>{props.children}</div>

        <Cookie />

        <FooterHeader
          heading={footer.heading}
          subHeading={footer.subHeading}
          hrOpacity="1"
        />

        <Footer
          lang={props.lang}
          slug={props.slug}
          tel={info.tel}
          email={info.mail}
          ulica={info.ulica}
          nrBud={info.nrBud}
          miasto={info.miasto}
          kod={info.kod}
          woj={info.woj}
          kraj={info.kraj}
          heading={footer.heading}
          subHeading={footer.subHeading}
        />

        <FooterIks hrOpacity="1" />
      </div>
    </ThemeProvider>
  )
}
export default Layout

export const footer = {
  heading: "Zapraszmy do kontaktu!",
  subHeading:
    "Z przyjemnością odpowiemy na wszelkie pytania i wątpliwości.\nObsługujemy klientów z całego kraju i zagranicy",
}
